//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState,
  mapMutations
} from "vuex";
import {
  forgetPassword
} from '../../service/index'
import {
  getCookie
} from '@/utils/storage'
let Base64 = require('js-base64').Base64;
export default {
  name: "Login",
  data() {
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('login.errorEmail')));
      }

      // var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      // if (!reg.test(value)) {
      //   callback(new Error(this.$t('login.errorEmail')));
      // } else {
      //   callback();
      // }
      callback()

    };
    return {
      campaign: {},
      loginForm: {
        userName: "",
        passWord: ""
      },
      formRules: {
        userName: [{
          required: true,
          validator: checkEmail,
          trigger: 'blur'
        }]
      },
    };
  },
  mounted() {
    this.keepLang()


  },
  computed: {
    ...mapState(["global"])
  },
  methods: {
    ...mapMutations({
      setTempName: 'SET_TEMPNAME'
    }),

    forgetPwd() {


      if (this.global.isPc) {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.sendForgetEmail()
          }
        })
      } else {
        this.sendForgetEmail()
      }
    },
    async sendForgetEmail() {
      if(!(/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/).test(this.loginForm.userName) && !this.global.isPc){
         this.$message({
          message: this.$t('login.errorEmail'),
          type: 'success'
        })
        return
      }
      const param = {
        username: this.loginForm.userName,
      }
      const loading = this.$loading({
        lock: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)',
        customClass: 'fullscree-loading'
      });

      const res = await forgetPassword(param);
      loading.close();
      if (res.status === 0) {
        this.$message({
          message: this.$t('login.sendMailSuccess'),
          type: 'success'
        })

        this.$router.push({
          path: '/login',
          query: {
            cid: this.$route.query.cid
          }
        })


      } else {
        this.$message({
          message: "Error! Please try again",
          type: 'error'
        })
      }



    },
    // 中英文切换事件
    switchLang() {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh';
        localStorage.locale = 'zh';
      } else {
        this.$i18n.locale = 'en';
        localStorage.locale = 'en';
      }
    },
    // 刷新页面保存语言
    keepLang() {
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },
  }
};




// WEBPACK FOOTER //
// ./src/pages/login/Forgetpwd.vue